module.exports = __webpack_public_path__ + "static/media/logo.b6e27b0e.png";